import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./a11y.css";

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
